'use strict'
const Base = require('../base.edit')
const ImageResize = require('../../helpers/image-resize')
const modal = new (require('../../helpers/modal'))
const ajax = require('../../helpers/ajax')
const sortnodes = require('../../helpers/sortnodes')

module.exports = class pureHtmlWidget extends Base {

	onInit() {

		let input = document.createElement('input')
		input.type = 'file'
		input.onchange = () => {
			this.popup(input.files[0])
			input.value = ''
		}

		let label = document.createElement('label')
		label.innerHTML = '<i class="material-icons">add_a_photo</i>'
		label.appendChild(input)
		this._elemButtons.appendChild(label)

		this.config = {
			width: this._config.width,
			height: this._config.height,
			padding: 200,
		}

		this.setActions()
		this.setDrag()

	}

	onDestroy() {
		if (typeof this.removeListener === 'function') {
			this.removeListener()
		}
		const images = this._widget.querySelectorAll('.image-wrapper')
		images.forEach(el => {
			el.onclick = null
		})
	}

	onSave() {
		this.cancelSort()
	}

	setActions() {
		const wrapper = this._widget.querySelector('.gallery-wrapper')
		const images = this._widget.querySelectorAll('.image-wrapper')
		images.forEach(el => {
			el.onclick = e => {
				e.preventDefault()
				this.removeAllActive()
				wrapper.classList.add('edit-tools-sorting')
				el.classList.add('edit-tools-sorting-active')
				this.imageButtons(el)
			}
		})
	}

	setDrag() {
		const wrapper = this._widget.querySelector('.gallery-wrapper')
		wrapper.classList.add('edit-tools-drag')
		this.removeListener = sortnodes(wrapper, '.image-wrapper',
			() => this.cancelSort(),
			(el, from, to) => {
				const arr = this._data.gallery
				arr.splice(to, 0, arr.splice(from, 1)[0])
				this.setActions()
			}
		)
	}

	removeAllActive() {
		const images = this._widget.querySelectorAll('.image-wrapper')
		images.forEach(el => {
			el.classList.remove('edit-tools-sorting-active')
		})
	}

	imageButtons(el) {

		let i = 0
		let child = el
		while ((child = child.previousElementSibling) != null) {
			i++
		}

		// const i = Array.from(el.parentNode).indexOf(el)

		this.clearTemp()

		let space = document.createElement('span')
		space.className = 'btn-space'

		let moveup = document.createElement('button')
		moveup.innerHTML = '<i class="material-icons">keyboard_arrow_left</i>'
		moveup.onclick = () => this.move(el, i, -1)
		moveup.disabled = i === 0

		let movedown = document.createElement('button')
		movedown.innerHTML = '<i class="material-icons">keyboard_arrow_right</i>'
		movedown.onclick = () => this.move(el, i, 1)
		movedown.disabled = i === this._data.gallery.length - 1

		let remove = document.createElement('button')
		remove.innerHTML = '<i class="material-icons">delete_forever</i>'
		remove.onclick = () => this.remove(el, i)

		let cancel = document.createElement('button')
		cancel.innerHTML = '<i class="material-icons">playlist_add_check</i>'
		cancel.onclick = () => this.cancelSort()

		let link = document.createElement('button')
		link.innerHTML = '<i class="material-icons">link</i>'
		link.onclick = () => this.btnTextLink()




		this.temp = []
		this.temp.push(space)
		this.temp.push(cancel)
		this.temp.push(moveup)
		this.temp.push(movedown)
		this.temp.push(remove)
		this.temp.push(link)
		this.temp.forEach(el => {
			this._elemButtons.appendChild(el)
		})


	}


	btnTextLink() {
		this.btnLink.innerHTML = '<i class="material-icons">link</i> &nbsp; ' +
			this._data.url || ''
	}

	cancelSort() {
		this.clearTemp()
		this.removeAllActive()
		this._widget.querySelector('.gallery-wrapper')
			.classList.remove('edit-tools-sorting')
	}

	clearTemp() {
		if (!this.temp) { return }
		this.temp.forEach(el => {
			el.remove()
		})
	}

	remove(el, i) {
		this._data.gallery.splice(i, 1)
		el.remove()
		this.clearTemp()
	}

	move(el, i, direction) {
		const g = this._data.gallery
		let item = g.splice(i, 1)[0]
		let j = i + direction
		if (direction > 0) {
			el.parentElement.insertBefore(el.nextElementSibling, el)
			g.splice(j, 0, item)
		}
		if (direction < 0) {
			el.parentElement.insertBefore(el, el.previousElementSibling)
			g.splice(j, 0, item)
		}
		this.imageButtons(el)
	}

	popup(file) {
		let title = 'Nahrajte obrazok'
		let block = document.createElement('div')
		block.className = 'uploader'

		this.IR = new ImageResize(this.config)
		this.IR.setFile(file)
		this.IR.setWrapper(block)
		modal.show(title, block)

		let btn = document.createElement('button')
		btn.innerHTML = '<i class="material-icons">done</i>'
		btn.className = 'btn'
		btn.onclick = () => {
			this.IR.done(blob => {
				ajax({
					url: '/api/upload/',
					method: 'PUT',
					data: blob,
				}).then(resp => {
					this._data.gallery.push({src: resp.path})
					this._render()
				})
				modal.hide()
			})
		}
		block.appendChild(btn)
		this.setPopupSize(block, btn)
	}

	setPopupSize(block, btn) {

		const w = this.config.width + this.config.padding
		const h = this.config.height + this.config.padding
		const maxw = window.innerWidth * 0.9
		const maxh = window.innerHeight * 0.9 - 100

		let zoom = 1
		if (maxw / w < zoom) { zoom = maxw / w }
		if (maxh / h < zoom) { zoom = maxh / h }

		block.style.width = w + 'px'
		block.style['min-height'] = h + 'px'
		block.style.zoom = zoom
		btn.style.zoom = 1 / zoom

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/gallery/gallery.edit.js
// module id = 453
// module chunks = 0